import axios from "axios";
import {hostWithPrefix} from "../Constructor/common/ApiCommon";
import {getQueryString} from "../OutputForms/Api";

export function findTemplateById(id, templateType) {
    return axios({
        url: 'http://' + hostWithPrefix + '/templates/' + templateType.toLowerCase() + "/" + id, //your url
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json', // important
    })
}

export function deleteTemplate(id) {
    return axios({
        url: 'http://' + hostWithPrefix + '/templates/' + id, //your url
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json', // important
    })
}

export function findTemplates(filters, sort, asc) {
    let qs = getQueryString(filters)
    if (sort !== undefined) {
        qs += "sort=" + sort + "&asc=" + asc
    }
    return axios({
        url: 'http://' + hostWithPrefix + '/templates' + qs,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}

export function packConstructorDataInObject(constructor) {
    if (constructor.templateType === 'DECADE') return packDecadeConstructor(constructor)
    if (constructor.templateType === 'TT') return packTTConstructor(constructor)
    if (constructor.type === 'RAIN_FLOOD') return packFloodConstructor(constructor)
    if (constructor.type === 'RIVER_FLOOD') return packFloodConstructor(constructor)
    if (constructor.type === 'EVAPORATION') return packEvapConstructor(constructor)
}

function packDecadeConstructor(res) {
    const constructorData = res

    const rows = []
    for (let i = 0; i < constructorData.reportTemplateFilters.length; i++) {
        let code = constructorData.reportTemplateFilters[i].meteoCode
        let datasourceType = constructorData.reportTemplateFilters[i].datasourceType
        let operation = constructorData.reportTemplateFilters[i].dailyOperation.code
        let stnEntity = constructorData.reportTemplateFilters[i].stnEntity

        rows.push({
            rowId: i,
            type: datasourceType,
            stnEntity: stnEntity,
            code: code,
            operation: operation
        })
    }

    return {
        id: constructorData.id,
        curRowNum: constructorData.reportTemplateFilters.length,
        type: constructorData.templateType,
        name: constructorData.name,
        station: constructorData.station,
        filtersRows: rows,
        withoutDays: constructorData.withoutDays,
        multiplyDimension: constructorData.multiplyDimension,
        duplicationType: constructorData.duplicateType,
        decadeOperations: constructorData.decadeOperations,
        tableOperations: constructorData.tableOperations,
        editable: false
    }
}

function packTTConstructor(res) {
    const constructorData = res

    const rows = []
    for (let i = 0; i < constructorData.reportTemplateFilters.length; i++) {
        let code = constructorData.reportTemplateFilters[i].meteoCode
        let datasourceType = constructorData.reportTemplateFilters[i].datasourceType
        let stnEntity = constructorData.reportTemplateFilters[i].stnEntity

        rows.push({
            rowId: i,
            type: datasourceType,
            code: code,
            stnEntity: stnEntity
        })
    }

    return {
        id: constructorData.id,
        curRowNum: constructorData.reportTemplateFilters.length,
        type: constructorData.templateType,
        name: constructorData.name,
        station: constructorData.station,
        filtersRows: rows,
        tableOperations: constructorData.tableOperations,
        editable: false
    }
}

function packFloodConstructor(res) {
    const constructorData = res

    return {
        id: constructorData.id == null ? null : constructorData.id,
        station: constructorData.station,
        name: constructorData.name,
        type: constructorData.type,
        coefficients: {
            A: constructorData.coefficients.a,
            B: constructorData.coefficients.b,
            C: constructorData.coefficients.c,
            D: constructorData.coefficients.d,
        },
        catchmentArea: constructorData.catchmentArea,
        equation: constructorData.equation.equationString,
        filters: constructorData.filters
    }
}

function packEvapConstructor(res) {
    const constructorData = res

    return {
        id: constructorData.id == null ? null : constructorData.id,
        station: constructorData.station,
        name: constructorData.name,
        type: constructorData.type,
        filters: constructorData.filter
    }
}